<template>
  <div class="headerBar" :class="headerStyle" >


          <div
            ref="main"
            class="main_container"
            :class="{ 'main-container-search': showSearch }"
          >
            <div class="left" ref="left">
              <router-link
                :to="{ name: 'Home' }"
                v-if="$store.state.webConfig.web_title"
              >
                <img
                  class="logo"
                  :src="
                    headerStyle == 'headerIndex headerWithBack'
                      ? $store.state.webConfig.manager_logo
                      : $store.state.webConfig.web_logo
                  "
                  v-if="$store.state.webConfig.web_logo"
                />
                <img v-else class="logo" src="@/assets/images/logo@2x.png" />
              </router-link>

              <span
                class="slogan"
                :class="{ 'opacity-hide': showSearch }"
                v-if="$store.state.webConfig.web_slogan"
                :title="$store.state.webConfig.web_slogan"
              >
                {{ $store.state.webConfig.web_slogan }}
              </span>
            </div>
            <HeaderSearch
              v-show="showSearch"
              :headerStyle="headerStyle"
              :show.sync="showSearch"
            ></HeaderSearch>
            <div
              class="header-main clearfix"
              :class="{ 'opacity-hide': showSearch }"
            >
              <HeaderMenu ref="menu" :headerStyle="headerStyle"></HeaderMenu>
              <div  style="margin-left: 100px;">
                <!-- <span >距考研还剩<span style="font-size: 20px;font-weight: 600;margin: 0 6px;color: #bb1c20;">{{ examDays }}</span>天</span> -->
              </div>
              <div class="search" @click.stop="onSearchBtnClick" style="margin-left: 20px;">
                <span class="search-btn-img"></span>
              </div>
              <HeaderSchool></HeaderSchool>
            </div>
            <div ref="right" class="right">
              <div
                v-if="$store.state.token"
                class="bell-wrap"
                @click="$router.push({ name: 'MemberMessage' })"
              >
                <i class="bell-wrap-img"></i>
                <span
                  v-if="
                    $store.state.token && $store.state.message.all.not_read > 0
                  "
                  :class="{
                    small: $store.state.message.all.not_read < 10,
                    middle:
                      $store.state.message.all.not_read > 9 &&
                      $store.state.message.all.not_read < 100,
                    big: $store.state.message.all.not_read > 99,
                  }"
                >
                  {{ $store.state.message.all.not_read_show }}
                </span>
              </div>
              <div class="userinfo">
                <el-dropdown
                  class="f-left"
                  v-if="$store.state.token"
                  @command="onStudentMenu"
                >
                  <!-- <div
                    class="lnk-login"
                    @click="$router.push({ name: 'MemberCalendar' })"
                  > -->
                  <div
                    class="lnk-login"
                  >
                    <img class="avatar" :src="$store.state.user_info.avatar" />
                    <!-- <span class="nickname">
                      <span
                        style="vertical-align: middle; display: inline-block"
                      >
                        {{ $store.state.user_info.nickname }}
                      </span>
                      <template
                        v-if="
                          $store.state.commonSetting.switch_state == 1 &&
                          $store.getters.showVip
                        "
                      >
                        <template
                          v-if="
                            $store.state.user_info.vip_info &&
                            $store.state.user_info.vip_info.icon_url &&
                            !getIsExpire($store.state.user_info.vip_info.end_at)
                          "
                        >
                          <img
                            :src="$store.state.user_info.vip_info.icon_url"
                            class="vip-logo"
                            @click.stop="$router.push({ name: 'Vip' })"
                          />
                        </template>
                        <template v-else>
                          <img
                            :src="iconUrl"
                            class="vip-logo"
                            @click.stop="$router.push({ name: 'Vip' })"
                          />
                        </template>
                      </template>
                    </span> -->
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="center">
                      个人中心
                    </el-dropdown-item>
                    <el-dropdown-item command="logout">
                      退出登录
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <template v-else>
                  <a
                    href="javascript:void(0)"
                    class="lnk-login-register btn-blank"
                    @click="
                      $LoginModal.login({
                        type: 'passwordLogin',
                        store: $store,
                      })
                    "
                  >
                    {{ $t("common.login") }}
                  </a>
                  <a
                    v-if="
                      $store.state.commonSetting.allow_student_register == 1
                    "
                    href="javascript:void(0)"
                    class="lnk-login-register btn-normal"
                    @click="
                      $LoginModal.login({
                        type: 'codeLogin',
                        store: $store,
                      })
                    "
                  >
                    注册
                  </a>
                </template>
              </div>
            </div>
          </div>
 
  </div>
</template>
<script>
import HeaderMenu from "./HeaderMenu.vue";
import HeaderSchool from "./HeaderSchool.vue";
import HeaderSearch from "./HeaderSearch.vue";

export default {
  name: "Header",
  components: {
    HeaderMenu,
    HeaderSchool,
    HeaderSearch,
  },
  data() {
    return {
      navigates: [],
      topFiveNavigates: [],
      showSearch: false,
      headerStyle: "",
      examDays:'--'
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.setHeaderCss(route.name);
      },
      // 深度观察监听
      deep: true,
    },
  },
  async created() {
    if (this.$store.state.token) {
      this.$store.dispatch("refreshMessageState");
    }
    this.setHeaderCss(this.$route.name);
    this.getExamDays()
  },
  computed: {
    bannerList() {
      return this.$store.state.indexData.bannerList;
    },
    iconUrl() {
      return this.$store.state.commonSetting.not_vip_icon;
    },
  },
  methods: {
    async getExamDays (){  
      const res = await this.$http.get('/api/app/kaoyan_time')

      this.examDays = this.daysUntil(res.postgraduate_set_time)
    },
    daysUntil(fixedDate) {
      if(fixedDate=='' || !fixedDate || fixedDate==null){
        return '--'
      }
        // 将字符串日期转换为日期对象
        const targetDate = new Date(fixedDate);
        // 获取今天的日期
        const today = new Date();
        // 将日期转换为毫秒数
        const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
        // 计算两个日期之间的差异（以毫秒为单位）
        const diff = targetDate - today;
        // 将差异转换为天数
        const daysLeft = Math.ceil(diff / oneDay);
        return daysLeft<0 ? 0 : daysLeft;
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.$route.name == "Index") {
        if (scrollTop > 50) {
          this.headerStyle = "headerIndex headerWithBack";
        } else if (this.bannerList && this.bannerList.length > 0) {
          this.headerStyle = "headerIndex headerWithBack";
        }
        this.$forceUpdate();
      }
    },
    setHeaderCss(name) {
      
      if (name == "Index" && this.bannerList && this.bannerList.length > 0) {
        this.headerStyle = "headerIndex headerWithBack";
      } else {
        this.headerStyle = "";
      }
      if (this.$store.state.indexData.bannerList.length == 0) {
        this.headerStyle = "headerIndex headerWithBack";
      }
      this.$forceUpdate();
    },
    //判断会员是否过期
    getIsExpire(time) {
      if (time) {
        const now = this.$actionTool.getCurTimestamp(); //当前时间的时间戳
        if (now > time) {
          //如果当前时间大于会员到期时间，说明已过期
          return true;
        }
      }
      return false;
    },
    onStudentMenu(command) {
      switch (command) {
        case "center":
          this.$router.push({ name: "MemberCalendar" });
          break;
        case "logout":
          this.$store.commit("logout");
          //this.$router.push({ name: "Course" });
          this.$router.push({ name: "Index" });
          break;
      }
    },
    onSearchBtnClick() {
      this.$router.push({ name: "SearchResult" });
      //this.showSearch = true;
    },
    handleResize() {
      if (!this.$refs.main) {
        return;
      }
      let mainWidth = this.$refs.main.offsetWidth;
      if (mainWidth == 1200) {
        return;
      }
      let width = document.documentElement.clientWidth;
      let leftWidth = this.$refs.left.offsetWidth;
      let rightWidth = this.$refs.right.offsetWidth;
      let surplus = width - leftWidth - rightWidth - 50 - 17;
      this.$refs.menu.setWidth(surplus);
    },
    onresetEl() {
      let that = this;
      that.handleResize();
      window.addEventListener("scroll", that.handleScroll);
      window.addEventListener("resize", that.handleResize);
      window.$(".headerBar").hover(
        function () {
          that.headerStyle = "headerIndex headerWithBack";
          that.$forceUpdate();
        },
        function () {
          that.handleScroll();
          that.$forceUpdate();
        },
      );
    },
  },
  mounted() {
    let that = this;
    if (this.$store.state.indexData.bannerList.length != 0) {
      that.$nextTick(() => {
        that.onresetEl("页面加载完");
      });
    }
    setTimeout(function () {
      that.onresetEl("重复一次");
    }, 1000);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.headerBar {
  height: 70px;
  line-height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: transparent;
  width: calc(100vw - 16px);
  z-index: 999;
  // box-shadow: 0px 4px 8px 0px rgba(224, 224, 224, 0.2);
  // overflow: hidden;
  // overflow-x: auto;
  // overflow: auto;
  // -ms-overflow-style: none;
  //  -webkit-overflow-scrolling: touch;
  // scrollbar-width: none;
  

  .main_container {
    height: 70px;
    line-height: 70px;
    display: flex;
    background: #fff;
    width: 1200px;
    padding-left: calc(50% - 600px);
    padding-right: calc(50% - 600px);

    margin: 0 auto;
  }



  .main-container-search {
    justify-content: space-between;
  }

  .left {
    display: flex;
    overflow: hidden;
  }



  .header-main {
    flex: 1;
    position: relative;
    margin-left: 30px;
    display: flex;
    opacity: 1;
    transition: all 0.5s;

    /deep/ {
      .nav-list {
        flex: 1;
        // justify-content: flex-end;
      }
    }
  }

  .right {
    float: right;
    display: flex;
  }

  .header-table {
    border-spacing: 0;
    // width: 100%;
    width: 100%;
    margin: 0 auto;
    line-height: 1;

    td {
      text-align: center;
    }
  }
}

.headerBar::-webkit-scrollbar {
      display: none;
    }

  @media only screen and (min-device-width: 520px) and (max-device-width: 1024px) {
    /* 平板样式调整 */
    // .left {
    //   display: none;
    // }
    .headerBar{
      
      width: 100vw;
    }
    .logo{
      margin-right: -20px;
    }
    .main_container {
      height: 70px;
      line-height: 70px;
      display: flex;
      padding: 0px 20px;
      width: calc(100% - 46px);
    }
  }


.headerIndex {
  // background: transparent;
  //background: #fff !important;
  // z-index: 1000000000000000000;
  box-shadow: none;
}
.headerWithBack {
  //background: #fff !important;
}
.logo {
  float: left;
  height: 36px;
  margin-top: 17px;
  margin-right: 20px;
}

.slogan {
  flex-grow: 1;
  font-size: 15px;
  color: #666;
  margin-left: 10px;
  position: relative;
  padding-left: 10px;
  white-space: nowrap;
  opacity: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
  // &::before {
  //   content: "";
  //   position: absolute;
  //   width: 1px;
  //   height: 20px;
  //   background: #666;
  //   left: 0;
  //   top: 25px;
  // }
}

.userinfo {
  float: left;
  position: relative;
  margin-left: 26px;
  display: flex;
  align-items: center;
  > div {
    display: flex;
  }
  .menus {
    position: absolute;
    top: 80px;
    right: 5px;
    width: 140px;
    opacity: 0;
    /deep/ .el-card__body {
      padding: 0;
    }
    li {
      font-size: 15px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: $primary-color-light;
      }
    }
  }
  .nickname {
    //height: 21px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(54, 56, 55, 1);
    //line-height: 21px;
  }
  .lnk-login {
    float: left;
    font-size: 16px;
    color: $primary-color;
    height: 70px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    outline: none;
    &:hover > .menus {
      top: 70px;
      opacity: 255;
    }
    .vip-logo {
      width: 18px;
      height: 18px;
      vertical-align: middle;
      position: relative;
      top: -1px;
      left: 2px;
      cursor: pointer;
    }
  }
  .lnk-login-register {
    width: 60px;
    height: 32px;
    display: inline-block;
    // padding: 6px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    &:first-child {
      margin-right: 10px;
    }
  }
}

.search {
  float: right;
  margin-top: 4px;
}

.search-btn-img {
  width: 24px;
  height: 24px;
  display: block;
  vertical-align: top;
  margin-top: 20px;
  cursor: pointer;
  background: url(~@/assets/images/common/Frame3017@2x.png) no-repeat;
  background-size: 24px 24px;
}

.avatar {
  width: 32px;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  border-radius: 50%;
  // margin-right: 25px;
}

.name {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.nickname {
  color: #333;
}

.header-school {
  margin-left: 24px;
}

.bell-wrap {
  float: left;
  margin-left: 24px;
  margin-top: 5px;
  position: relative;
  cursor: pointer;
  .bell-wrap-img {
    width: 24px;
    height: 24px;
    background: url(~@/assets/images/common/Frame3018@2x.png) no-repeat;
    background-size: 24px 24px;
    display: inline-block;
    vertical-align: top;
    margin-top: 18px;
  }
  span {
    position: absolute;
    height: 18px;
    background: rgba(255, 43, 78, 1);
    border-radius: 9px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 18px;
    top: 12px;
    left: 13px;
    text-align: center;

    &.small {
      width: 18px;
    }

    &.middle {
      width: 28px;
    }

    &.big {
      width: 34px;
    }
  }
}
.opacity-hide {
  position: relative;
  opacity: 0 !important;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
}
.headerWithBack {
  .slogan {
    // color: rgba(255, 255, 255, 0.8);
  }
  .nav-list {
    .item {
      span {
        // color: rgba(255, 255, 255, 0.8);
      }
    }
  }
  .search-btn-img {
    background: url(~@/assets/images/common/Frame3017@2x.png) no-repeat;
    background-size: 24px 24px;
  }
  .btn-blank {
    // border: 1px solid rgba(255, 255, 255, 0.8) !important;
    // color: rgba(255, 255, 255, 0.8) !important;
  }
  .btn-normal {
    // border: 1px solid $primary-color !important;
    background: $primary-color;
  }
  .bell-wrap-img {
    background: url(~@/assets/images/common/Frame3018@2x.png) no-repeat;
    background-size: 24px 24px;
  }
  .nickname {
    // color: rgba(255, 255, 255, 0.8) !important;
  }
}
</style>
<style lang="scss">
.el-dropdown-menu__item {
  text-align: center;
}
</style>
